<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <ul>
            <div class="pci"><img :src="form.url" alt="" width="300px" /></div>
            <div class="name">{{ form.name }}</div>
            <div class="name">{{ form.introduce }}</div>
            <li v-for="item in form.list" :key="item.id" class="li-item">
              <div class="hotel" @click="goToDetail(item)">
                {{ item.hotel }}
              </div>
              <div class="address">地址：{{ item.address }}</div>
              <div class="address">联系电话：{{ item.phone }}</div>
              <div class="hotelIntroduce">{{ item.hotelIntroduce }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      form: {
        url: require("@/assets/images/jdbk.jpg"),
        name: "酒店板块",
        introduce:
          "酒店板块是天津旅游集团的传统支柱产业之一，长期以来保持持续稳定的发展。",
        list: [
          {
            id: 1,
            hotel: "天津利顺德大饭店有限公司",
            address: "天津和平区台儿庄路33号",
            phone: "022-23311688",
            hotelIntroduce: "百年历史，欧式酒店",
          },
          {
            id: 2,
            hotel: "天津燕园国际大酒店有限责任公司",
            address: "天津河西区紫金山路",
            phone: "022-27313388",
            hotelIntroduce:
              "天津燕园国际大酒店是集商务，住宿，餐饮，休闲等为一体的豪华酒店。酒店...",
          },
          {
            id: 3,
            hotel: "天津利顺德大厦有限公司",
            address: "天津市和平区台儿庄路32号",
            phone: "022-23032888",
            hotelIntroduce:
              "中外合作企业的利顺德大厦是天津高端四星级涉外国际公寓酒店之一，地处...",
          },
          {
            id: 4,
            hotel: "天津市友谊宾馆有限公司",
            address: "天津市和平区南京路94号",
            phone: "022-23310373",
            hotelIntroduce:
              "天津市友谊宾馆坐落于市中心著名的南京路上，地处小白楼商业街和滨江道步行...",
          },
          {
            id: 5,
            hotel: "天津津旅康养职业培训学校有限公司",
            address: "天津市静海区健康产业园内",
            phone: "28772877",
            hotelIntroduce:
              "泊泰温泉是天津旅游集团下属企业，位于天津市静海团泊新城西区康宁津园内，...",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    goToDetail(item) {
      if (item.id == 1) {
        this.$router.push("/lsddfd");
      } else if (item.id == 2) {
        this.$router.push("/tjyygj");
      } else if (item.id == 3) {
        this.$router.push("/lsdds");
      } else if (item.id == 4) {
        this.$router.push("/yybg");
      } else if (item.id == 5) {
        this.$router.push("/jljk");
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 0px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      .pci {
        margin-top: 20px;
        text-align: center;
      }
      .name {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        color: #1c5c88;
        text-align: center;
        margin-top: 15px;
      }
      .hotel {
        cursor: pointer;
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        font-weight: bold;
      }
      .hotel:hover {
        color: red;
        text-decoration: underline;
      }
      .address {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        color: #777;
      }
      .hotelIntroduce {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        color: #2d5b89;
      }
      .li-item {
        text-align: center;
        width: 100%;
        // height: 202px;
        background: #ffffff;
        // border-bottom: 1px solid #e5e5e5;
        padding: 15px 103px 20px 40px;
        box-sizing: border-box;
      }
      .wp_single.wp_column_article {
        padding: 15px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          border-bottom: 1px #444 dashed;
          height: 500px;
        }
      }
      .text {
        text-indent: 45px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>